<div class="catalog-content">
    <app-uplaod-thumbnail [data]="data" [articleList]="articleList" [typeList]="typeList" (typeChange)="onTypeChange($event)"></app-uplaod-thumbnail>
    <app-list-thumbnail [data]="articleList" [type]="selectedType"></app-list-thumbnail>
</div>